import { Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@planning/AppProvider'
import {
  InboundDashboardCard,
  OutboundDashboardCard,
  RestowDetailsDashboardCard,
} from '@planning/components'
import { CarrierType, CarrierVisitStatus } from '@planning/app/api'
import { IVesselVisitItem } from '@planning/rt-stores/vesselVisit/VesselVisitItem'
import { formatDateTime } from '@planning/utils'
import { BackButton, ContainerMobile, Header, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { TallymanOperationStoppedAlert } from './molecules/TallymanOperationStoppedAlert'

interface Props {
  item: IVesselVisitItem
  onBack: () => void
  onWorkAssignmentsSelection: () => void
}

export const VisitDetails = observer(({ item, onBack, onWorkAssignmentsSelection }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const title = item?.data?.number
    ? `${item.data.number} - ${item.vessels[0]?.data.name}`
    : item.vessels[0]?.data.name
  const { restowItemStore } = usePlanningStore()
  useEffect(() => {
    restowItemStore.fetchByVesselVisitId(item.id)
  }, [restowItemStore, item.id])

  return (
    <>
      <Header
        leftRenderOption={
          item.status === CarrierVisitStatus.InOperation ? <BackButton onGoBack={onBack} /> : null
        }
      />

      <ContainerMobile
        sx={{
          pt: theme.customSpacing.l,
          backgroundColor: theme.palette.grey[200],
          minHeight: 'calc(100vh - 65px)',
          padding: '1rem',
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <Stack gap={theme.customSpacing.m} width='100%'>
          <Stack>
            <Typography variant='subtitle1' fontWeight='600' color={theme.palette.secondary.dark}>
              {title}
            </Typography>
            <Typography variant='caption' fontWeight='400' color={theme.palette.secondary.dark}>
              {`${t('ata', 'ATA')}: ${formatDateTime(item.data.ata)}`}
            </Typography>
          </Stack>
          <InboundDashboardCard
            isTallyPage
            visitId={item?.data.id}
            orders={item?.discharge.orders ?? []}
            visitType={CarrierType.Vessel}
            visitStatus={item?.data.status}
            cargoType={item?.data.cargoType}
            isMinimalisticView={true}
          />
          <OutboundDashboardCard
            isTallyPage
            visitId={item?.data.id}
            orders={item?.load.orders ?? []}
            visitType={CarrierType.Vessel}
            visitStatus={item?.data.status}
            cargoType={item?.data.cargoType}
            isMinimalisticView={true}
          />
          <RestowDetailsDashboardCard
            isTallyPage
            visitId={item?.data.id}
            restows={item?.restow.orders ?? []}
            visitType={CarrierType.Vessel}
            visitStatus={item?.data.status}
            cargoType={item?.data.cargoType}
            isMinimalisticView={true}
          />

          <TallymanOperationStoppedAlert onWorkAssignmentsSelection={onWorkAssignmentsSelection} />
        </Stack>
      </ContainerMobile>
    </>
  )
})
